import './PatreonCTA.css'

const PatreonCTA = () => {
  return (
    <section className="patreon-cta">
      <div className="patreon-content">
        <div className="patreon-icon">
          <i className="fab fa-patreon"></i>
        </div>
        <h2 className="patreon-title">support the signal</h2>
        <p className="patreon-description">
        keep the signal moving and get full length tutorials, early access to new sessions, and a growing library of in-depth resources and exclusive downloads. 
        </p>
        <a href="https://patreon.com/nessakodo?utm_medium=clipboard_copy&utm_source=copyLink&utm_campaign=creatorshare_creator&utm_content=join_link" target="_blank" rel="noopener noreferrer" className="patreon-button">
          support my patreon
        </a>
      </div>
    </section>
  )
}

export default PatreonCTA
